if ( typeof MultipackPicker !== 'function' ) {

	class MultipackPicker extends HTMLElement {

		constructor() {

			super();

			this.sectionId = this.dataset.sectionId;
			this.form = document.getElementById(`product-form-${this.sectionId}`);
			this.idInput = this.form ? this.form.querySelector('input[name="id"]') : null;
			this.quantityInput = this.form ? this.form.querySelector('input[name="quantity"]') : null;
			this.sealsubs = this.form ? this.form.querySelector('.sealsubs-target-element') : null;
			this.priceValue = this.querySelector('[data-js-multipack-price-value]');
			this.inputs = this.querySelectorAll('.multipack-picker__input');
			this.groups = this.querySelectorAll('[data-multipack-group]');

			this.inputs.forEach((input) => {
				input.addEventListener('change', () => this.onTierChange(input));
			});

			if ( this.groups.length ) {
				this.productVariants = document.querySelector(`product-variants[data-id="${this.sectionId}"]`);
				if ( this.productVariants ) {
					this.productVariants.addEventListener('VARIANT_CHANGE', () => this.onMainVariantChange());
				}
			}

		}

		onMainVariantChange() {

			if ( ! this.productVariants || ! this.productVariants.currentVariant ) return;

			const variantId = this.productVariants.currentVariant.id;
			let activeGroup = null;

			this.groups.forEach((group) => {
				const isMatch = group.dataset.variantId == variantId;
				group.hidden = ! isMatch;
				if ( isMatch ) activeGroup = group;
			});

			if ( ! activeGroup ) return;

			const baseInput = activeGroup.querySelector('[data-is-base="true"]');
			if ( baseInput ) {
				baseInput.checked = true;
				this.onTierChange(baseInput);
			}

		}

		onTierChange(input) {

			const variantId = input.dataset.variantId;
			const unitPriceCents = parseInt(input.dataset.unitPriceCents, 10);
			const totalPriceCents = parseInt(input.dataset.totalPriceCents, 10);
			const isBase = input.dataset.isBase === 'true';
			const available = input.dataset.available === 'true';
			const inventoryManagement = input.dataset.inventoryManagement || null;
			const inventoryQuantity = parseInt(input.dataset.inventoryQuantity, 10) || 0;

			if ( this.idInput && variantId ) {
				this.idInput.value = variantId;
				this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
			}

			if ( this.quantityInput ) {
				this.quantityInput.value = 1;
				this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
			}

			if ( this.priceValue ) {
				this.priceValue.innerHTML = this._formatMoney(unitPriceCents, KROWN.settings.shop_money_format);
			}

			if ( this.sealsubs ) {
				this.sealsubs.style.display = isBase ? '' : 'none';
			}

			this._updatePageVisiblePrice(totalPriceCents, input);

			// Sticky add-to-cart pruh (viz component-sticky-add-to-cart.js) si
			// cenu bundlu nemůže vzít z VARIANT_CHANGE — currentVariant tam
			// zůstává napočítaný z opcí hlavního produktu, ne ze skrytého id
			// inputu, který sem přepínáme na variantu bundle produktu.
			this.dispatchEvent(new CustomEvent('MULTIPACK_TIER_CHANGE', {
				bubbles: true,
				detail: { isBase, totalPriceCents, available, inventoryManagement, inventoryQuantity },
			}));

		}

		// Hlavní cena a cena za jednotku (Kč/praní apod.) zobrazené mimo tento
		// picker (nahoře u produktu, v buy_buttons bloku) se jinak nemění —
		// VARIANT_CHANGE z <product-variants> se na výběr tieru nenavazuje
		// (viz komentář u MULTIPACK_TIER_CHANGE výše). Dopočítá se tu i cena
		// za jednotku (praní/sušení/...), protože bundle varianta nemá vlastní
		// unit_price_measurement — vychází se z product.metafields.custom.quantity
		// (počet jednotek v „1 balení") krát počet balení v tieru.
		_updatePageVisiblePrice(totalPriceCents, input) {

			const container = document.getElementById(`product-${this.sectionId}`) || document;
			const packCount = parseInt(input.dataset.packCount, 10) || 1;

			container.querySelectorAll('[data-js-product-price-original]').forEach((el) => {
				el.innerHTML = this._formatMoney(totalPriceCents, KROWN.settings.shop_money_format);
			});

			// Dvě vzájemně se vylučující varianty "ceny za jednotku" podle
			// product-price.liquid: produkty s metafieldem custom.quantity
			// (praní/dávky/...) vs. produkty s nativním Shopify unit pricingem
			// (Kč/kus, Kč/kg...), které metafield nemají (např. houbičky).
			this._updateUnitPriceEls(container, '[data-js-product-price-unit]', parseInt(this.dataset.quantityPerPack, 10), packCount, totalPriceCents);
			this._updateUnitPriceEls(container, '[data-js-product-price-unit-value]', parseFloat(this.dataset.nativeUnitsPerPack), packCount, totalPriceCents);

		}

		_updateUnitPriceEls(container, selector, unitsPerPack, packCount, totalPriceCents) {

			if ( ! (unitsPerPack > 0) ) return;

			const perUnitCents = Math.floor(totalPriceCents / (unitsPerPack * packCount));

			container.querySelectorAll(selector).forEach((el) => {
				if ( el.dataset.unitSuffix === undefined ) {
					el.dataset.unitSuffix = el.textContent.trim().split('/').pop().trim();
				}
				el.innerHTML = `${this._formatMoney(perUnitCents, KROWN.settings.shop_money_format)}/${el.dataset.unitSuffix}`;
			});

		}

		_formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}

			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;

			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';

				if (isNaN(number) || number === null) {
					return 0;
				}

				number = (number / 100.0).toFixed(precision);

				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';

				return dollarsAmount + centsAmount;
			}

			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}

			return formatString.replace(placeholderRegex, value);

		}

	}

	if ( typeof customElements.get('multipack-picker') == 'undefined' ) {
		customElements.define('multipack-picker', MultipackPicker);
	}

}
